import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'app-snack-bar',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SnackBarComponent implements OnInit {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, public snackBarRef: MatSnackBarRef<SnackBarComponent>,
  ) { }

  ngOnInit() {
    // Intentionally left blank for future initialization logic
  }

  get icon() {
    switch (this.data.snackType) {
      case 'success': 
        return 'check_circle';
      case 'error':
        return 'info';
      case 'warning':
        return 'warning';
    }
    return true;
  }

  closeSnackBar() {
    this.snackBarRef.dismiss();
  }

}
